<template>
  <div class="steps-container">
    <template v-for="(step, index) in steps">
      <div class="step" :class="{ active: index < currentStep }" :key="`step-${index}`">
        <i class="material-icons"
           v-text="index + 1 < currentStep ? 'circle' : (index + 1 === currentStep ? 'radio_button_checked' : 'radio_button_unchecked')"></i>
        <span>{{ step }}</span>
      </div>
      <div class="section" :class="{ active: index + 1 < currentStep }" v-if="index + 1 < steps.length" :key="`section-${index}`"></div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: ['currentStep', 'steps']
}
</script>

<style scoped>
.steps-container {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
}

.section {
  flex-grow: 1;
  height: 5px;
  margin: 0 -3px;
  background-color: var(--exatom-grey);
}

.section.active {
  background-color: var(--primary);
}

.step {
  display: flex;
  color: var(--exatom-grey);
  position: relative;
}

.step.active {
  color: var(--primary);
}

.step i {
  font-size: 18px;
  z-index: 1;
}

.step span {
  position: absolute;
  white-space: nowrap;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 10px;
}
</style>
